module.exports = __webpack_public_path__ + "media/myweddingmusic.mp3";